const data = (collection, keyword) => {
  return (
    collection &&
    Object.values(collection).filter((item) => {
      let available = false;
      if (item.attributes.name.toLowerCase().includes(keyword.toLowerCase()))
        available = true;

      return available;
    })
  );
};

export default data;
